// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import { ConfigProvider } from 'antd';
import History from './pages/History'; 
import HistoryTimeline from './pages/HistoryTimeline'; 
import OurPastors from './pages/OurPastors'; 
import OrganizationalStructure from './pages/OrganizationalStructure'; 
import ContactUs from './pages/ContactUs'; 
import Navbar from './components/Navbar';
import './App.css';
import CustomFooter from './components/CustomFooter';
import ChurchDetails from './pages/ChurchDetails';
import FaithDeclaration from './pages/FaithDeclaration';
import ChurchRequestDetails from './pages/ChurchRequestDetails';
import PrayerRequestDetails from './pages/PrayerRequestDetails';
import Constitution from './pages/Constitution';
const App = () => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#fa8c16",
          colorBgBase: "#ffffff",
          colorText: '#610b00',
          fontFamily: `"Trebuchet MS", Tahoma, sans-serif`
        },
      }}
    >
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/history" element={<History />} />
          <Route path="/faith-declaration" element={<FaithDeclaration />} />
          <Route path="/history-timeline" element={<HistoryTimeline />} />
          <Route path="/our-pastors" element={<OurPastors />} />
          <Route path="/church-constitution" element={<Constitution />} />
          <Route path="/organizational-structure" element={<OrganizationalStructure />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/church/:churchId" element={<ChurchDetails />} />
          <Route path="/church-request/:requestId" element={<ChurchRequestDetails />} /> 
          <Route path="/prayer-request/:requestId" element={<PrayerRequestDetails />} /> 
        </Routes>
        <CustomFooter></CustomFooter>
      </Router>
    </ConfigProvider>
  );
};

export default App;
